// src/components/FormSections/FormSectionGenerales.js

import React, { useState, useCallback } from "react"
import { Row, Col } from "reactstrap"
import FormikInput from "../Common/Formik/FormikInput"
import FormikInputPassword from "../Common/Formik/FormikInputPassword"
import FormikDatePicker from "../Common/Formik/FormikDatePicker"
import FormikInputCurp from "../Common/Formik/FormikInputCurp"
import FormikInputEmailPersonal from "../Common/Formik/FormikInputEmailPersonal"
import FormikSelect from "../Common/Formik/FormikSelect"
import DropzoneComponent from "../Common/DropzoneComponent"
import ImageCropComponent from "../Common/ImageCropComponent"

import Webcam from "../Common/WebcamComponent"
import { Link } from "react-router-dom"

// Opciones para selects (pueden ser importadas desde un archivo separado)
import {
  estadosFederativosOptions,
  paisesOptions,
  estadosCivilesOptions,
} from "../../utils/catalogoOptions"

const FormSectionGenerales = ({
  formik,
  handleUpperCaseChange,
  handleLowerCaseChange,
  isLoading,
  resetForm,
}) => {
  const [dataImage, setDataImage] = useState("")
  const [dataCropImage, setDataCropImage] = useState("")
  const [showWebcam, setShowWebcam] = useState(false)
  const [showCropComponent, setShowCropComponent] = useState(false)
  const [showDropZone, setShowDropZone] = useState(false)
  const [userImageUrl, setUserImageUrl] = useState(
    "https://avatar.iran.liara.run/public"
  )

  // #region functions

  const toggleCropComponentVisibility = useCallback(() => {
    setShowCropComponent(!showCropComponent)
  }, [setShowCropComponent, showCropComponent])

  const fnRecibirCropImage = useCallback(
    base64Image => {
      console.log(base64Image)
      setDataCropImage(base64Image)
      toggleCropComponentVisibility()()
    },
    [setDataCropImage, toggleCropComponentVisibility]
  )
  const toggleWebcamVisibility = useCallback(() => {
    setShowWebcam(!showWebcam)
  }, [setShowWebcam, showWebcam])

  const toggleDropZoneVisibility = useCallback(() => {
    setShowDropZone(!showDropZone)
  }, [setShowDropZone, showDropZone])

  const receiveBase64 = useCallback(
    (base64Image, control) => {
      console.log(control)
      setDataImage(base64Image)
      if (control === "webcam") {
        toggleWebcamVisibility()
      } else {
        toggleDropZoneVisibility()
      }
      toggleCropComponentVisibility()
    },
    [
      setDataImage,
      toggleWebcamVisibility,
      toggleDropZoneVisibility,
      toggleCropComponentVisibility,
    ]
  )

  const handleDropAccepted = useCallback(
    ({ formData, base64Files, identificator }) => {
      receiveBase64(base64Files[0], "dropcomponent")
    },
    [receiveBase64]
  )

  const handleBlurIntercept = (event, formik) => {
    //console.log("Interceptando onBlur en:", event.target.name)

    const Nombres = formik.values["Nombres"]
    const Apellido_Paterno = formik.values["Apellido_Paterno"]
    const Apellido_Materno = formik.values["Apellido_Materno"]

    formik.setFieldValue(
      "Nombre_Alumno",
      Nombres + " " + Apellido_Paterno + " " + Apellido_Materno
    )

    // Llamar al onBlur de Formik manualmente
    formik.handleBlur(event)
  }

  // #endregion

  return (
    <>
      <DropzoneComponent
        onDropAccepted={handleDropAccepted}
        isOpen={showDropZone}
        maxFiles={1}
      />
      <ImageCropComponent
        isVisible={showCropComponent}
        base64={dataImage}
        fnRecibirCropImage={fnRecibirCropImage}
      />
      {/* Sección de Información General */}
      <h5 className="mb-4">Información General</h5>
      {/* 1er Row Apellido_Paterno && Curp */}
      {/* Curp, Email, Password */}
      {/* Foto */}
      <Row>
        <Col md={10}>
          {/* Curp, Apellido_Paterno, Apellido_Materno, Nombres */}
          <Row>
            <Col md={3}>
              <div className="mb-3">
                <FormikInputCurp
                  label="* CURP"
                  name="Curp"
                  placeholder="CURP"
                  formik={formik}
                  onChange={handleUpperCaseChange}
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <FormikInput
                  label="* Apellido Paterno"
                  name="Apellido_Paterno"
                  placeholder="Apellido Paterno"
                  formik={formik}
                  onChange={handleUpperCaseChange}
                  onBlur={event => handleBlurIntercept(event, formik)}
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <FormikInput
                  label="Apellido Materno"
                  name="Apellido_Materno"
                  placeholder="Apellido Materno"
                  formik={formik}
                  onChange={handleUpperCaseChange}
                  onBlur={event => handleBlurIntercept(event, formik)}
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <FormikInput
                  label="* Nombres"
                  name="Nombres"
                  placeholder="Nombres"
                  formik={formik}
                  onChange={handleUpperCaseChange}
                  onBlur={event => handleBlurIntercept(event, formik)}
                />
              </div>
            </Col>
          </Row>
          {/* Email, Password, Estado Civil */}
          <Row>
            <Col md={4}>
              <div className="mb-3">
                <FormikInputEmailPersonal
                  label="* Email Personal"
                  name="Email_Personal"
                  type="email"
                  placeholder="correo@ejemplo.com"
                  formik={formik}
                  onChange={handleLowerCaseChange}
                />
              </div>
            </Col>{" "}
            <Col md={4}>
              <div className="mb-3">
                <FormikInputPassword
                  label="* Contraseña"
                  name="Password"
                  placeholder="Contraseña"
                  formik={formik}
                  onChange={formik.handleChange}
                />
              </div>
            </Col>{" "}
            <Col md={4}>
              <div className="mb-3">
                <FormikSelect
                  label="* Estado Civil"
                  name="id_Estado_Civil"
                  options={estadosCivilesOptions}
                  formik={formik}
                  placeholder="Selecciona Estado Civil"
                />
              </div>
            </Col>
          </Row>
        </Col>

        {/* Foto */}
        <Col md={2}>
          {" "}
          <div className="text-center">
            {showWebcam ? (
              <Webcam
                isOpen={showWebcam}
                onClose={toggleWebcamVisibility}
                recibe={receiveBase64}
                size={{ width: 1024, height: 768 }}
              />
            ) : (
              <img
                src={dataCropImage ? dataCropImage : userImageUrl}
                width={341}
                alt=""
                className="avatar-xl rounded d-block mx-auto" //className="avatar-xxl rounded position-relative z-n1"
              />
            )}
            <Row className="icon-demo-content">
              {!showWebcam && !showCropComponent && (
                <>
                  <Col>
                    <Link onClick={toggleWebcamVisibility}>
                      <i className="bx bx-camera icon-hover-effect me-2"></i>
                    </Link>
                  </Col>
                  <Col>
                    <Link onClick={toggleDropZoneVisibility}>
                      <i className="bx bx-cloud-upload icon-hover-effect me-2"></i>
                    </Link>
                  </Col>
                </>
              )}
            </Row>
            {/* <i className="bx bxs-file-jpg"></i> */}
          </div>
        </Col>
      </Row>
      {/* Género, Telefono Celular, Otro Telefono */}
      <Row>
        <Col md={3}>
          {/* Suponiendo que Sexo es un radio button */}
          <div className="mb-3">
            <label className="form-label">Sexo</label>
            <div>
              <label className="me-3">
                <input
                  type="radio"
                  name="Sexo"
                  value="1"
                  checked={formik.values.Sexo === 1}
                  onChange={() => formik.setFieldValue("Sexo", 1)}
                />{" "}
                Masculino
              </label>
              <label>
                <input
                  type="radio"
                  name="Sexo"
                  value="0"
                  checked={formik.values.Sexo === 0}
                  onChange={() => formik.setFieldValue("Sexo", 0)}
                />{" "}
                Femenino
              </label>
            </div>
            {formik.touched.Sexo && formik.errors.Sexo && (
              <div className="text-danger">{formik.errors.Sexo}</div>
            )}
          </div>
        </Col>
        <Col md={3}>
          <div className="mb-3">
            <FormikInput
              label="* Teléfono Celular"
              name="Telefono_Celular"
              placeholder="1234567890"
              formik={formik}
              onChange={formik.handleChange}
              mask="9999999999" // Si usas InputMask dentro de FormikInput
            />
          </div>
        </Col>
        {/* <Col md={3}>
          <div className="mb-3">
            <FormikInput
              label="Otro Teléfono"
              name="Telefono_Fijo3"
              placeholder="1234567890"
              formik={formik}
              onChange={formik.handleChange}
              mask="9999999999" // Si usas InputMask dentro de FormikInput
            />
          </div>
        </Col> */}
      </Row>
      {/* Ciudad Nacimiento, Estado, Pais */}
      <Row>
        <Col md={6}>
          <div className="mb-3">
            <FormikInput
              label="* Ciudad de Nacimiento"
              name="Ciudad_Nacimiento"
              placeholder="Ciudad"
              formik={formik}
              onChange={handleUpperCaseChange}
            />
          </div>
        </Col>
        <Col md={3}>
          <div className="mb-3">
            <FormikSelect
              label="* Estado de Nacimiento"
              name="id_Estado_Nacimiento"
              options={estadosFederativosOptions}
              formik={formik}
              placeholder="Selecciona Estado"
            />
          </div>
        </Col>
        <Col md={3}>
          <div className="mb-3">
            <FormikSelect
              label="* País de Nacimiento"
              name="id_Pais_Nacimiento"
              options={paisesOptions}
              formik={formik}
              placeholder="Selecciona País"
              default
            />
          </div>
        </Col>
      </Row>
      {/* Fecha Nacimiento */}
      <Row>
        <Col md={6}>
          <div className="mb-3">
            <FormikDatePicker
              label="Fecha de Nacimiento"
              name="Fecha_Nacimiento"
              placeholder="Selecciona tu fecha de nacimiento"
              dateFormat="Y-m-d"
              formik={formik}
            />
          </div>
        </Col>
      </Row>
    </>
  )
}

export default FormSectionGenerales
